import { LogManager } from '../../../../common/port/log/log.manager.port';
import { TeamMetricsMeetingsSummaryTotalIndividualAggregateRootMapper } from '../../../../infrastructure/mappers/team-metrics/summary/team-metrics-meetings-summary-total-individual.aggregate-root.mapper';
import { GetTeamMetricsMeetingsSummaryTotalIndividualRequestDto } from '../../../dtos/team-metrics/summary/get-team-metrics-meetings-summary-total-individual.request.dto';
import { GetTeamMetricsMeetingsSummaryResponseDto } from '../../../dtos/team-metrics/summary/get-team-metrics-meetings-summary.response.dto';
import { GetTeamMetricsMeetingsSummaryTotalIndividualQuery } from '../../../queries/team-metrics/summary/get-team-metrics-meetings-summary-total-individual.query';

export class GetTeamMetricsMeetingsSummaryTotalIndividualController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetTeamMetricsMeetingsSummaryTotalIndividualQuery,
    protected readonly mapper: TeamMetricsMeetingsSummaryTotalIndividualAggregateRootMapper
  ) {}

  async get(
    props: GetTeamMetricsMeetingsSummaryTotalIndividualRequestDto
  ): Promise<GetTeamMetricsMeetingsSummaryResponseDto> {
    try {
      const result = await this.query.execute(props);
      return this.mapper.toResponse(result);
    } catch (error) {
      throw new Error(
        `GetTeamMetricsMeetingsSummaryTotalIndividualController.get encountered an error: ${error}`
      );
    }
  }
}
